module.exports = __webpack_public_path__ + "img/ranking_img_five.56caa622.png";